import {Button} from "@mui/material";
import {FC} from "react";
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import {IButtonProps} from "@ui/buttons/buttonCustom/types";

const ButtonCustom: FC<IButtonProps> = ({
                                            sx,
                                            size = 'small',
                                            fullWidth = false,
                                            type,
                                            variant,
                                            disabled,
                                            label,
                                            children,
                                            onClick,
                                            startIcon,
                                            endIcon,
                                            color,
                                            component = 'button',
                                            className,
                                            autoFocus,
                                            ...rest
                                        }) => {

    const {theme} = useThemeContext()


    return (
        <Button
            sx={sx}
            size={size}
            fullWidth={fullWidth}
            type={type}
            onClick={onClick}
            variant={variant}
            disabled={disabled}
            startIcon={startIcon}
            endIcon={endIcon}
            component={component as any}
            color={theme === 'dark' ? undefined : color}
            className={className}
            autoFocus={autoFocus}
            {...rest}
        >
            {label && label}
            {children && children}
        </Button>
    );
};

export default ButtonCustom;